import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-16-sound-on.tsx
/**
* icon.16.sound.on
*
* Keywords: speaker, volume, audio, loud, soundwave, increase, amplification
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJtNSAxMCAxIDEgMSAxVjRMNiA1IDUgNkgzLjVhLjUuNSAwIDAgMC0uNS41djNhLjUuNSAwIDAgMCAuNS41em0xLjI5My02LjcwN0w0LjU4NiA1SDMuNUExLjUgMS41IDAgMCAwIDIgNi41djNBMS41IDEuNSAwIDAgMCAzLjUgMTFoMS4wODZsMS43MDcgMS43MDdBMSAxIDAgMCAwIDggMTJWNGExIDEgMCAwIDAtMS43MDctLjcwN20zLjIwNiA5LjY4M2MtLjI3NC4wMjctLjQ5OS0uMi0uNDk5LS40NzZzLjIyNS0uNDk3LjQ5OS0uNTNhNCA0IDAgMCAwIDAtNy45NEM5LjIyNSAzLjk5OCA5IDMuNzc3IDkgMy41cy4yMjUtLjUwMy41LS40NzVhNSA1IDAgMCAxIDAgOS45NW0tLjAwMS0yLjAxN0M5LjIyNiAxMS4wMDUgOSAxMC43NzYgOSAxMC41cy4yMjctLjQ5My40OTUtLjU2MmEyIDIgMCAwIDAgMC0zLjg3NkM5LjIyNyA1Ljk5NCA5IDUuNzc2IDkgNS41cy4yMjYtLjUwNC40OTgtLjQ1OWEzIDMgMCAwIDEgMCA1LjkxOG0tLjAxOS0yLjA4MUM5LjIzNyA5LjAxIDkgOC43NzYgOSA4LjV2LTFjMC0uMjc2LjIzNy0uNTEuNDgtLjM3OGExIDEgMCAwIDEgMCAxLjc1NiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-13374
*/
const Icon16SoundOn = memo(function Icon16SoundOn(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "m5 10 1 1 1 1V4L6 5 5 6H3.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5zm1.293-6.707L4.586 5H3.5A1.5 1.5 0 0 0 2 6.5v3A1.5 1.5 0 0 0 3.5 11h1.086l1.707 1.707A1 1 0 0 0 8 12V4a1 1 0 0 0-1.707-.707m3.206 9.683c-.274.027-.499-.2-.499-.476s.225-.497.499-.53a4 4 0 0 0 0-7.94C9.225 3.998 9 3.777 9 3.5s.225-.503.5-.475a5 5 0 0 1 0 9.95m-.001-2.017C9.226 11.005 9 10.776 9 10.5s.227-.493.495-.562a2 2 0 0 0 0-3.876C9.227 5.994 9 5.776 9 5.5s.226-.504.498-.459a3 3 0 0 1 0 5.918m-.019-2.081C9.237 9.01 9 8.776 9 8.5v-1c0-.276.237-.51.48-.378a1 1 0 0 1 0 1.756",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon16SoundOn };

//# sourceMappingURL=icon-16-sound-on.js.map